import { Box, Grid, Paper, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import {
  AppFormikButtonStateTiles,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const PaperFormQuality: React.FC<PaperFormCharacteristicProps> = () => {
  const { setFieldValue } = useFormikContext();

  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Quality & Validation</Typography>
        <Box className="paper-form-input-content">
          <Grid container spacing={4} className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikTextArea
                outerLabel
                label="Known Data Quality Issues"
                placeholder="Describe any known quality issues "
                name="dataqualityissue"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextArea
                outerLabel
                label="Validation Summary"
                placeholder="Summarize validation efforts"
                name="validationsummary"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                className="metadata-available"
              >
                <Typography component="span">Metadata Available</Typography>
                <AppFormikButtonStateTiles
                  variant="outlined"
                  name="metadata"
                  size="small"
                  label=""
                  multichoice={false}
                  className="button-tiles-status"
                  buttons={[
                    {
                      value: 'Disable',
                      onClick: (e: any) => {
                        if (e.target.classList.contains('MuiButtonBase-root')) {
                          if (e.target.classList.contains('selected')) {
                            setFieldValue('metadata', [false, true]);
                          }
                        } else {
                          const DomList: DOMTokenList =
                            e.target.offsetParent.classList;

                          if (DomList.contains('selected')) {
                            setFieldValue('metadata', [false, true]);
                          }
                        }
                      },
                    },
                    {
                      value: 'Enable',
                      onClick: (e: any) => {
                        if (e.target.classList.contains('MuiButtonBase-root')) {
                          if (e.target.classList.contains('selected')) {
                            setFieldValue('metadata', [false, true]);
                          }
                        } else {
                          const DomList: DOMTokenList =
                            e.target.offsetParent.classList;

                          if (DomList.contains('selected')) {
                            setFieldValue('metadata', [true, false]);
                          }
                        }
                      },
                    },
                  ]}
                  outerLabel
                />
              </Stack>
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                className="metadata-available"
              >
                <Typography component="span">Datasheet Available</Typography>
                <AppFormikButtonStateTiles
                  variant="outlined"
                  name="datasheet"
                  size="small"
                  label=""
                  multichoice={false}
                  className="button-tiles-status"
                  buttons={[
                    {
                      value: 'Disable',
                      onClick: (e: any) => {
                        if (e.target.classList.contains('MuiButtonBase-root')) {
                          if (e.target.classList.contains('selected')) {
                            setFieldValue('datasheet', [false, true]);
                          }
                        } else {
                          const DomList: DOMTokenList =
                            e.target.offsetParent.classList;

                          if (DomList.contains('selected')) {
                            setFieldValue('datasheet', [false, true]);
                          }
                        }
                      },
                    },
                    {
                      value: 'Enable',
                      onClick: (e: any) => {
                        if (e.target.classList.contains('MuiButtonBase-root')) {
                          if (e.target.classList.contains('selected')) {
                            setFieldValue('datasheet', [false, true]);
                          }
                        } else {
                          const DomList: DOMTokenList =
                            e.target.offsetParent.classList;

                          if (DomList.contains('selected')) {
                            setFieldValue('datasheet', [true, false]);
                          }
                        }
                      },
                    },
                  ]}
                  outerLabel
                />
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <AppFormikTextField
                outerLabel
                label="Data Dictionary Link"
                placeholder="https:// ..."
                name="dictionarylink"
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaperFormQuality;
